import React, { useEffect, useState, useRef } from "react";
import { getAllVip } from "../api/vipform";
import { useVipStore } from "../context/VipContext";
import { useNavigate } from "react-router-dom";

const guardDistribution = {
  "Bollywood Actor": ["Grade A - 1", "Grade B - 1", "Grade C - 2", "Grade E - 10"],
  Cricketers: ["Grade B - 1", "Grade C - 1", "Grade D - 5", "Grade E - 10"],
  Chessmaster: ["Grade B - 1", "Grade C - 2", "Grade E - 10"],
  User: ["Grade D - 2", "Grade E - 15"],
};

export default function VipGuardManagement() {
  const { refreshTrigger } = useVipStore();
  const [vipList, setVipList] = useState([]);

  const [selectedDesignation, setSelectedDesignation] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [searchText, setSearchText] = useState("");

  const [popupData, setPopupData] = useState(null);
  const [popupPos, setPopupPos] = useState({ top: 0, left: 0 });

  const role = localStorage.getItem("role");
  const navigate = useNavigate();
  const rowRefs = useRef({});

  /* PAGINATION */
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(30);

  /* FETCH VIP LIST */
  useEffect(() => {
    async function load() {
      try {
        const data = await getAllVip();
        if (Array.isArray(data)) setVipList(data);
        else if (Array.isArray(data?.data)) setVipList(data.data);
      } catch (err) {
        console.error("Fetch VIP Error:", err);
      }
    }
    load();
  }, [refreshTrigger]);

  /* FILTER + SEARCH */
  const designations = [...new Set(vipList.map((v) => v.designation))];

  const filtered = vipList.filter((v) => {
    if (!["Active", "Inactive"].includes(v.status)) return false;

    const desMatch = selectedDesignation ? v.designation === selectedDesignation : true;
    const statusMatch = selectedStatus ? v.status === selectedStatus : true;

    const text = searchText.trim().toLowerCase();
    const searchMatch = text
      ? [v.name, v.email, v.contactno, v.designation]
          .some((field) => String(field || "").toLowerCase().includes(text))
      : true;

    return desMatch && statusMatch && searchMatch;
  });

  /* PAGINATION LOGIC */
  const totalPages = Math.ceil(filtered.length / rowsPerPage);
  const currentData = filtered.slice(
    (currentPage - 1) * rowsPerPage,
    currentPage * rowsPerPage
  );

  const goToPage = (page) => {
    if (page >= 1 && page <= totalPages) setCurrentPage(page);
  };

  /* POPUP */
  const openPopup = (e, vip, id) => {
    e.stopPropagation();

    if (popupData?.id === id) {
      setPopupData(null);
      return;
    }

    const row = rowRefs.current[id];
    if (!row) return;
    const rect = row.getBoundingClientRect();

    setPopupPos({
      top: rect.bottom + window.scrollY + 12,
      left: rect.left + window.scrollX + rect.width / 2 - 160,
    });

    setPopupData({ ...vip, id });
  };

  const closePopup = () => setPopupData(null);

  return (
    <div className="vgm-wrapper">
      {/* Header */}
      <header className="vgm-header">
        <h1>VIP Officer Assignments</h1>
        <p>View and assign required security officers for each VIP</p>
      </header>

      {/* Filters */}
      <section className="filters-grid">
        <div className="filter-card">
          <label>Designation</label>
          <select
            value={selectedDesignation}
            onChange={(e) => {
              setSelectedDesignation(e.target.value);
              setCurrentPage(1);
            }}
          >
            <option value="">All Designations</option>
            {designations.map((d, i) => (
              <option key={i} value={d}>{d}</option>
            ))}
          </select>
        </div>

        <div className="filter-card">
          <label>Status</label>
          <select
            value={selectedStatus}
            onChange={(e) => {
              setSelectedStatus(e.target.value);
              setCurrentPage(1);
            }}
          >
            <option value="">All Status</option>
            <option value="Active">Active</option>
            <option value="Inactive">Inactive</option>
          </select>
        </div>

        <div className="filter-card search">
          <label>Search</label>
          <div className="search-input">
            <input
              type="text"
              value={searchText}
              onChange={(e) => {
                setSearchText(e.target.value);
                setCurrentPage(1);
              }}
              placeholder="Name, email, contact..."
            />
            <i className="fas fa-search"></i>
          </div>
        </div>
      </section>

      {/* Table Card */}
      <section className="table-section">
        <div className="table-card">
          {currentData.length === 0 ? (
            <div className="no-records">
              <i className="fas fa-users-slash"></i>
              <p>No VIP records found</p>
            </div>
          ) : (
            <>
              <div className="table-responsive">
                <table className="vgm-table">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Name</th>
                      <th>Email</th>
                      <th>Designation</th>
                      <th>Contact</th>
                      <th>Status</th>
                      {/* {role === "user" && <th>Actions</th>} */}
                    </tr>
                  </thead>
                  <tbody>
                    {currentData.map((vip, index) => {
                      const isClickable = role === "user";
                      return (
                        <tr
                          key={vip.id}
                          ref={(el) => (rowRefs.current[vip.id] = el)}
                          className={isClickable ? "clickable" : ""}
                          onClick={() => {
                            if (isClickable) {
                              navigate(`/vip-auto-assign`, { state: { vip } });
                            }
                          }}
                        >
                          <td>{index + 1 + (currentPage - 1) * rowsPerPage}</td>
                          <td className="name">{vip.name}</td>
                          <td>{vip.email}</td>
                          <td>
                            <span className="badge designation">{vip.designation}</span>
                          </td>
                          <td>{vip.contactno}</td>
                          <td>
                            <span className={`badge status ${vip.status.toLowerCase()}`}>
                              {vip.status}
                            </span>
                          </td>
                          {/* {role === "user" && (
                            <td className="actions">
                              <button
                                className="action-btn info"
                                onClick={(e) => openPopup(e, vip, vip.id)}
                                title="View Required Officers"
                              >
                                <i className="fas fa-eye"></i>
                              </button>
                            </td>
                          )} */}
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>

              {/* Pagination */}
              {totalPages > 1 && (
                <div className="pagination">
                  <button
                    onClick={() => goToPage(currentPage - 1)}
                    disabled={currentPage === 1}
                    className="page-btn"
                  >
                    <i className="fas fa-chevron-left"></i>
                  </button>

                  <div className="page-numbers">
                    {[...Array(totalPages)].map((_, i) => (
                      <button
                        key={i}
                        onClick={() => goToPage(i + 1)}
                        className={currentPage === i + 1 ? "active" : ""}
                      >
                        {i + 1}
                      </button>
                    ))}
                  </div>

                  <button
                    onClick={() => goToPage(currentPage + 1)}
                    disabled={currentPage === totalPages}
                    className="page-btn"
                  >
                    <i className="fas fa-chevron-right"></i>
                  </button>

                  <select
                    value={rowsPerPage}
                    onChange={(e) => {
                      setRowsPerPage(Number(e.target.value));
                      setCurrentPage(1);
                    }}
                    className="rows-select"
                  >
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={30}>30</option>
                  </select>
                </div>
              )}
            </>
          )}
        </div>
      </section>

      {/* Popup */}
      {popupData && (
        <div className="popup-overlay" onClick={closePopup}>
          <div
            className="requirements-popup"
            style={{ top: popupPos.top, left: popupPos.left }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="popup-header">
              <h3>{popupData.name}</h3>
              <button onClick={closePopup} className="close-btn">
                <i className="fas fa-times"></i>
              </button>
            </div>
            <div className="popup-content">
              <p><i className="fas fa-envelope"></i> {popupData.email}</p>
              <p><i className="fas fa-briefcase"></i> {popupData.designation}</p>
              <p><i className="fas fa-phone"></i> {popupData.contactno}</p>

              <div className="guard-requirements">
                <h4>Required Officers</h4>
                <ul>
                  {(guardDistribution[popupData.designation] || ["No requirements defined"]).map((req, i) => (
                    <li key={i}>
                      <i className="fas fa-shield-alt"></i> {req}
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Matching UserDashboard Dark Glassmorphic Styling */}
      <style jsx>{`
        .vgm-wrapper {
          min-height: 100vh;
          background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);
          color: #e2e8f0;
          padding: 2rem;
        }

        .vgm-header {
          text-align: center;
          margin-bottom: 2rem;
        }

        .vgm-header h1 {
          font-size: 2.2rem;
          font-weight: 700;
          color: #34d399;
          margin-bottom: 0.5rem;
        }

        .vgm-header p {
          opacity: 0.85;
          font-size: 1.1rem;
        }

        .filters-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
          gap: 1.5rem;
          margin-bottom: 2rem;
        }

        .filter-card {
          background: rgba(30, 41, 59, 0.8);
          backdrop-filter: blur(12px);
          border-radius: 16px;
          padding: 1.5rem;
          border: 1px solid rgba(16, 185, 129, 0.3);
          transition: all 0.3s ease;
        }

        .filter-card:hover {
          transform: translateY(-4px);
          box-shadow: 0 12px 30px rgba(16, 185, 129, 0.15);
        }

        .filter-card label {
          display: block;
          margin-bottom: 0.7rem;
          font-weight: 600;
          color: #94a3b8;
        }

        .filter-card select,
        .search-input input {
          width: 100%;
          padding: 0.9rem 1rem;
          border-radius: 12px;
          border: 1px solid rgba(16, 185, 129, 0.4);
          background: rgba(15, 23, 42, 0.7);
          color: #e2e8f0;
          font-size: 1rem;
          transition: all 0.3s ease;
        }

        .filter-card select:focus,
        .search-input input:focus {
          outline: none;
          border-color: #34d399;
          box-shadow: 0 0 0 3px rgba(52, 211, 153, 0.2);
        }

        .search-input {
          position: relative;
        }

        .search-input .fa-search {
          position: absolute;
          right: 1.2rem;
          top: 50%;
          transform: translateY(-50%);
          color: #34d399;
          font-size: 1.1rem;
          pointer-events: none;
        }

        .table-section {
          margin-bottom: 2rem;
        }

        .table-card {
          background: rgba(30, 41, 59, 0.8);
          backdrop-filter: blur(12px);
          border-radius: 16px;
          border: 1px solid rgba(16, 185, 129, 0.3);
          overflow: hidden;
          box-shadow: 0 12px 35px rgba(0, 0, 0, 0.3);
        }

        .table-responsive {
          overflow-x: auto;
        }

        .vgm-table {
          width: 100%;
          border-collapse: separate;
          border-spacing: 0;
        }

        .vgm-table th {
          background: rgba(15, 23, 42, 0.9);
          padding: 1.3rem 1rem;
          text-align: left;
          color: #34d399;
          font-weight: 600;
          font-size: 0.95rem;
          border-bottom: 1px solid rgba(16, 185, 129, 0.3);
        }

        .vgm-table td {
          padding: 1.1rem 1rem;
          border-bottom: 1px solid rgba(100, 116, 139, 0.2);
        }

        .clickable {
          cursor: pointer;
          transition: all 0.3s ease;
        }

        .clickable:hover {
          background: rgba(16, 185, 129, 0.15);
          transform: translateY(-3px);
        }

        .name {
          font-weight: 600;
          color: #ffffff;
          font-size: 1.05rem;
        }

        .badge {
          padding: 0.5rem 1rem;
          border-radius: 20px;
          font-size: 0.9rem;
          font-weight: 600;
        }

        .badge.designation {
          background: linear-gradient(135deg, #10b981, #059669);
          color: white;
        }

        .badge.status.active {
          background: rgba(16, 185, 129, 0.2);
          color: #34d399;
          border: 1px solid #34d399;
        }

        .badge.status.inactive {
          background: rgba(239, 68, 68, 0.2);
          color: #fca5a5;
          border: 1px solid #ef4444;
        }

        .actions {
          text-align: center;
        }

        .action-btn {
          background: #10b981;
          color: white;
          border: none;
          width: 42px;
          height: 42px;
          border-radius: 12px;
          cursor: pointer;
          transition: all 0.3s ease;
          font-size: 1.1rem;
        }

        .action-btn:hover {
          background: #059669;
          transform: scale(1.15);
          box-shadow: 0 0 20px rgba(16, 185, 129, 0.6);
        }

        .no-records {
          text-align: center;
          padding: 4rem 2rem;
          color: #64748b;
        }

        .no-records i {
          font-size: 3.5rem;
          margin-bottom: 1rem;
          opacity: 0.6;
        }

        .pagination {
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 1rem;
          padding: 1.5rem;
          flex-wrap: wrap;
        }

        .page-btn {
          background: rgba(15, 23, 42, 0.8);
          color: #e2e8f0;
          border: 1px solid rgba(16, 185, 129, 0.4);
          width: 44px;
          height: 44px;
          border-radius: 12px;
          cursor: pointer;
          transition: all 0.3s ease;
        }

        .page-btn:hover:not(:disabled) {
          background: #10b981;
          transform: translateY(-3px);
        }

        .page-btn:disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }

        .page-numbers button {
          background: rgba(15, 23, 42, 0.6);
          color: #cbd5e1;
          width: 44px;
          height: 44px;
          border-radius: 12px;
          border: none;
          margin: 0 5px;
          cursor: pointer;
          font-weight: 600;
        }

        .page-numbers button.active {
          background: #10b981;
          color: white;
          box-shadow: 0 0 20px rgba(16, 185, 129, 0.4);
        }

        .rows-select {
          padding: 0.7rem 1.2rem;
          border-radius: 12px;
          background: rgba(15, 23, 42, 0.8);
          color: #e2e8f0;
          border: 1px solid rgba(16, 185, 129, 0.4);
        }

        .popup-overlay {
          position: fixed;
          inset: 0;
          z-index: 9998;
        }

        .requirements-popup {
          position: absolute;
          width: 340px;
          background: rgba(30, 41, 59, 0.98);
          backdrop-filter: blur(16px);
          border-radius: 16px;
          border: 1px solid rgba(16, 185, 129, 0.5);
          box-shadow: 0 20px 50px rgba(0, 0, 0, 0.6);
          z-index: 9999;
          animation: popupIn 0.3s ease-out;
        }

        @keyframes popupIn {
          from { opacity: 0; transform: scale(0.95); }
          to { opacity: 1; transform: scale(1); }
        }

        .popup-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 1.3rem 1.6rem;
          background: rgba(16, 185, 129, 0.15);
          border-bottom: 1px solid rgba(100, 116, 139, 0.3);
        }

        .popup-header h3 {
          margin: 0;
          font-size: 1.4rem;
          color: #34d399;
          font-weight: 700;
        }

        .close-btn {
          background: none;
          border: none;
          color: #94a3b8;
          font-size: 1.4rem;
          cursor: pointer;
        }

        .close-btn:hover {
          color: #ef4444;
        }

        .popup-content {
          padding: 1.6rem;
        }

        .popup-content p {
          margin: 0.9rem 0;
          display: flex;
          align-items: center;
          gap: 1rem;
          color: #cbd5e1;
        }

        .popup-content i {
          color: #34d399;
          width: 22px;
        }

        .guard-requirements h4 {
          margin: 1.4rem 0 1rem;
          color: #34d399;
          font-size: 1.2rem;
        }

        .guard-requirements ul {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .guard-requirements li {
          padding: 0.7rem 0;
          display: flex;
          align-items: center;
          gap: 1rem;
          color: #e2e8f0;
          border-bottom: 1px solid rgba(100, 116, 139, 0.2);
        }

        .guard-requirements li:last-child {
          border-bottom: none;
        }

        @media (max-width: 991px) {
          .vgm-wrapper { padding: 1.5rem; }
          .filters-grid { grid-template-columns: 1fr; }
          .vgm-header h1 { font-size: 2rem; }
          .requirements-popup {
            width: 90%;
            left: 5% !important;
            transform: none;
          }
        }
      `}</style>
    </div>
  );
}



// import React, { useEffect, useState, useRef } from "react";
// import { getAllVip, deleteVip } from "../api/vipform";
// import { useVipStore } from "../context/VipContext";
// import { useNavigate } from "react-router-dom";
// import { toast } from "react-toastify";

// /* ------------------ STATIC GUARD REQUIREMENT ------------------ */
// const guardDistribution = {
//   "Bollywood Actor": ["Grade A - 1", "Grade B - 1", "Grade C - 2", "Grade E - 10"],
//   Cricketers: ["Grade B - 1", "Grade C - 1", "Grade D - 5", "Grade E - 10"],
//   Chessmaster: ["Grade B - 1", "Grade C - 2", "Grade E - 10"],
//   User: ["Grade D - 2", "Grade E - 15"],
// };

// export default function VipGuardManagement() {
//   const { handleEdit, refreshTrigger } = useVipStore();
//   const [vipList, setVipList] = useState([]);

//   const [selectedDesignation, setSelectedDesignation] = useState("");
//   const [selectedStatus, setSelectedStatus] = useState("");
//   const [searchText, setSearchText] = useState(""); //  SEARCH STATE

//   const [popupData, setPopupData] = useState(null);
//   const [popupPos, setPopupPos] = useState({ top: 0, left: 0 });

//   const role = localStorage.getItem("role");

//   const navigate = useNavigate();
//   const rowRefs = useRef({});

//   /* PAGINATION */
//   const [currentPage, setCurrentPage] = useState(1);
//   const [rowsPerPage, setRowsPerPage] = useState(30);

//   /* ---------------- FETCH VIP LIST ---------------- */
//   useEffect(() => {
//     async function load() {
//       try {
//         const data = await getAllVip();
//         if (Array.isArray(data)) setVipList(data);
//         else if (Array.isArray(data?.data)) setVipList(data.data);
//       } catch (err) {
//         console.error("Fetch VIP Error:", err);
//       }
//     }
//     load();
//   }, [refreshTrigger]);

//   /* ---------------- FILTER + SEARCH ---------------- */
//   const designations = [...new Set(vipList.map((v) => v.designation))];

//   const filtered = vipList.filter((v) => {
//   // ✅ ONLY allow Active or Inactive
//   if (!["Active", "Inactive"].includes(v.status)) return false;

//   const desMatch = selectedDesignation
//     ? v.designation === selectedDesignation
//     : true;

//   const statusMatch = selectedStatus
//     ? v.status === selectedStatus
//     : true;

//   const text = searchText.trim().toLowerCase();
//   const searchMatch = text
//     ? [v.name, v.email, v.contactno, v.designation]
//         .some((field) =>
//           String(field || "").toLowerCase().includes(text)
//         )
//     : true;

//   return desMatch && statusMatch && searchMatch;
// });


//   /* PAGINATION LOGIC */
//   const totalPages = Math.ceil(filtered.length / rowsPerPage);

//   const currentData = filtered.slice(
//     (currentPage - 1) * rowsPerPage,
//     currentPage * rowsPerPage
//   );

//   const goToPage = (page) => {
//     if (page >= 1 && page <= totalPages) setCurrentPage(page);
//   };

//   /* ---------------- POPUP ---------------- */
//   const openPopup = (e, vip, id) => {
//     e.stopPropagation();

//     if (popupData?.id === id) {
//       setPopupData(null);
//       return;
//     }

//     const row = rowRefs.current[id];
//     const rect = row.getBoundingClientRect();

//     setPopupPos({
//       top: rect.top - 150,
//       left: rect.left + rect.width / 2 - 130,
//     });

//     setPopupData({ ...vip, id });
//   };

//   return (
//     <div style={styles.container}>
//       <h2 style={styles.title}>VIP Officer Assignments</h2>

//       {/* ---------------- FILTERS ---------------- */}
//       <div style={styles.filterRow}>
        
//         <div style={styles.filterCard}>
//           <label style={styles.filterLabel}>Designation</label>
//           <select
//             value={selectedDesignation}
//             onChange={(e) => {
//               setSelectedDesignation(e.target.value);
//               setCurrentPage(1);
//             }}
//             style={styles.select}
//           >
//             <option value="">All</option>
//             {designations.map((d, i) => (
//               <option key={i}>{d}</option>
//             ))}
//           </select>
//         </div>

//         <div style={styles.filterCard}>
//           <label style={styles.filterLabel}>Status</label>
//           <select
//             value={selectedStatus}
//             onChange={(e) => {
//               setSelectedStatus(e.target.value);
//               setCurrentPage(1);
//             }}
//             style={styles.select}
//           >
//             <option value="">All</option>
//             <option>Active</option>
//             <option>Inactive</option>
//           </select>
//         </div>
//         {/*  SEARCH BOX */}
//         <div style={styles.filterCard}>
//           <label style={styles.filterLabel}>Search</label>
//           <input
//             type="text"
//             value={searchText}
//             onChange={(e) => {
//               setSearchText(e.target.value);
//               setCurrentPage(1);
//             }}
//             placeholder="Search by name, email, contact..."
//             style={styles.input}
//           />
//         </div>

//       </div>

//       {/* VIP TABLE */}
//       <div style={styles.card}>
//         {currentData.length === 0 ? (
//           <div style={styles.noData}>No VIP Records Found</div>
//         ) : (
//           <table style={styles.table}>
//             <thead>
//               <tr>
//                 <th style={styles.th}>#</th>
//                 <th style={styles.th}>Name</th>
//                 <th style={styles.th}>Email</th>
//                 <th style={styles.th}>Designation</th>
//                 <th style={styles.th}>Contact</th>
//                 <th style={styles.th}>Status</th>
//                 {role === "user" && <th style={styles.th}>Actions</th>}
//               </tr>
//             </thead>

//             <tbody>
//               {currentData.map((vip, index) => {
//                 const statusStyle =
//                   vip.status === "Active"
//                     ? styles.statusActive
//                     : vip.status === "Inactive"
//                     ? styles.statusInactive
//                     : styles.statusOther;

//                 return (
//                   <tr
//                     key={vip.id}
//                     ref={(el) => (rowRefs.current[vip.id] = el)}
//                     style={{
//                       ...styles.row,
//                       cursor: role === "user" ? "pointer" : "not-allowed",
//                       opacity: role === "admin" ? 0.7 : 1,
//                     }}
//                     onClick={() => {
//                       if (role === "user") {
//                         navigate(`/vip-auto-assign`, { state: { vip } });
//                       }
//                     }}
//                   >
//                     <td style={styles.td}>{index + 1 + (currentPage - 1) * rowsPerPage}</td>
//                     <td style={styles.td}>{vip.name}</td>
//                     <td style={styles.td}>{vip.email}</td>
//                     <td style={styles.td}>
//                       <span style={styles.badge}>{vip.designation}</span>
//                     </td>
//                     <td style={styles.td}>{vip.contactno}</td>
//                     <td style={styles.td}>
//                       <span style={statusStyle}>{vip.status}</span>
//                     </td>

//                     {role === "user" && (
//                       <td style={styles.actionCol}>
//                         <button
//                           style={styles.infoBtn}
//                           onClick={(e) => openPopup(e, vip, vip.id)}
//                         >
//                           <i className="fa fa-eye"></i>
//                         </button>
//                       </td>
//                     )}
//                   </tr>
//                 );
//               })}
//             </tbody>
//           </table>
//         )}

//         {/* PAGINATION */}
//         {totalPages > 1 && (
//           <div style={styles.paginationContainer}>
//             <button
//               disabled={currentPage === 1}
//               style={styles.pageBtn}
//               onClick={() => goToPage(currentPage - 1)}
//             >
//               Prev
//             </button>

//             {[...Array(totalPages)].map((_, i) => (
//               <button
//                 key={i}
//                 style={{
//                   ...styles.pageBtn,
//                   ...(currentPage === i + 1 ? styles.activePage : {}),
//                 }}
//                 onClick={() => goToPage(i + 1)}
//               >
//                 {i + 1}
//               </button>
//             ))}

//             <button
//               disabled={currentPage === totalPages}
//               style={styles.pageBtn}
//               onClick={() => goToPage(currentPage + 1)}
//             >
//               Next
//             </button>

//             <select
//               value={rowsPerPage}
//               style={styles.rowsSelect}
//               onChange={(e) => {
//                 setRowsPerPage(Number(e.target.value));
//                 setCurrentPage(1);
//               }}
//             >
//               <option value={30}>30 / Page</option>
//               <option value={20}>20 / Page</option>
//               <option value={10}>10 / Page</option>
//             </select>
//           </div>
//         )}
//       </div>

//       {/* POPUP (NO CHANGE) */}
//       {popupData && (
//         <div
//           style={{ ...styles.popup, top: popupPos.top, left: popupPos.left }}
//           onMouseLeave={() => setPopupData(null)}
//         >
//           <div style={styles.arrow}></div>

//           <h3 style={styles.popupTitle}>{popupData.name}</h3>
//           <p style={styles.popText}>📧 {popupData.email}</p>
//           <p style={styles.popText}>🎖 {popupData.designation}</p>
//           <p style={styles.popText}>📞 {popupData.contactno}</p>

//           <h4 style={{ fontWeight: 700, marginTop: 10 }}>Required Officers:</h4>

//           {(guardDistribution[popupData.designation] || []).map((item, i) => (
//             <p key={i} style={styles.popText}>
//               {item}
//             </p>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// }

// /* ------------------------------ STYLES ----------------------------- */
// const styles = {
//   container: { padding: 30, background: "linear-gradient(135deg, rgba(145,195,243,0.7), rgba(233,239,125,0.9))" },
//   title: { fontSize: 30, fontWeight: 800, marginBottom: 25, color: "#1967d2" },

//   filterRow: { display: "flex", gap: 20, marginBottom: 25 },
//   filterCard: {
//     flex: 1,
//     padding: 18,
//     borderRadius: 12,
//     background: "rgba(255,255,255,0.45)",
//     boxShadow: "0 3px 12px rgba(0,0,0,0.08)",
//   },
//   filterLabel: { fontSize: 15, fontWeight: 600, marginBottom: 6 },

//   select: {
//     width: "100%",
//     padding: "12px",
//     borderRadius: 8,
//     border: "1.5px solid #1a73e8",
//     fontSize: 15,
//   },

//   input: {                          //  SEARCH INPUT STYLE
//     width: "100%",
//     padding: 12,
//     borderRadius: 8,
//     border: "1.5px solid #1a73e8",
//     fontSize: 15,
//     outline: "none",
//   },

//   card: { background: "rgba(255,255,255,0.7)", padding: 10, borderRadius: 15, boxShadow: "0 6px 25px rgba(0,0,0,0.1)" },
//   table: { width: "100%", borderCollapse: "collapse" },
//   th: { background: "#f4f4f6", padding: "16px 10px", textAlign: "left", borderBottom: "2px solid #ddd", fontWeight: 700 },
//   row: { height: 62, transition: "0.25s", cursor: "pointer" },
//   td: { padding: "14px 10px", borderBottom: "1px solid #eee" },

//   badge: { background: "#d7ecff", padding: "6px 12px", borderRadius: 8, color: "#005bb7", fontWeight: 600 },

//   infoBtn: { background: "#1976d2", padding: "7px 12px", border: 0, color: "#fff", borderRadius: 8 },

//   statusActive: { background: "#e6ffe6", padding: "6px 12px", borderRadius: 20, color: "#2e7d32", fontWeight: 600 },
//   statusInactive: { background: "#ffe6e6", padding: "6px 12px", borderRadius: 20, color: "#d32f2f", fontWeight: 600 },
//   statusOther: { background: "#fff8e1", padding: "6px 12px", borderRadius: 20, color: "#ff9800", fontWeight: 600 },

//   noData: { textAlign: "center", padding: 40, fontSize: 18, color: "#777" },

//   paginationContainer: { display: "flex", justifyContent: "center", gap: 10, padding: 15 },
//   pageBtn: {
//     padding: "6px 14px",
//     borderRadius: 6,
//     border: "1px solid #1967d2",
//     background: "white",
//     cursor: "pointer",
//   },
//   activePage: { background: "#1967d2", color: "#fff", fontWeight: 700 },
//   rowsSelect: { padding: "6px 14px", borderRadius: 6, border: "1px solid #1967d2" },

//   popup: {
//     position: "absolute",
//     background: "#ffffff",
//     padding: 18,
//     width: 260,
//     borderRadius: 12,
//     boxShadow: "0 8px 25px rgba(0,0,0,0.25)",
//     zIndex: 5000,
//   },
//   arrow: {
//     position: "absolute",
//     bottom: "-10px",
//     left: "50%",
//     transform: "translateX(-50%)",
//     width: 0,
//     height: 0,
//     borderLeft: "10px solid transparent",
//     borderRight: "10px solid transparent",
//     borderTop: "10px solid white",
//   },
//   popupTitle: { fontSize: 18, fontWeight: 700, marginBottom: 10 },
//   popText: { margin: "6px 0", fontSize: 14, color: "#333" },
// };
